<template>
  <div class="notification-type-card-grid">
    <div class="notification-type-card-grid__toolbar">
      <div class="notification-type-card-grid__heading">{{ heading }}</div>
      <v-text-field
        v-model="query"
        class="notification-type-card-grid__search"
        outlined
        dense
        hide-details
        :placeholder="searchPlaceholder"
        prepend-inner-icon="mdi-magnify"
        data-testid="notification-stepper__type-search"
      />
    </div>
    <div class="notification-type-card-grid__cards">
      <p v-if="!filteredTypes.length" class="notification-type-card-grid__empty">No matching types</p>
      <button
        v-for="card in filteredTypes"
        :key="card.feature"
        type="button"
        class="notification-type-card-grid__card"
        :class="{
          'notification-type-card-grid__card--selected': value === card.feature,
          'notification-type-card-grid__card--disabled': card.disabled,
        }"
        :disabled="card.disabled"
        :data-testid="`notification-stepper__type-card--${card.feature}`"
        @click="$emit('input', card.feature)"
      >
        <span class="notification-type-card-grid__icon" aria-hidden="true">
          <v-icon small>{{ card.icon || 'mdi-bell-outline' }}</v-icon>
        </span>
        <span class="notification-type-card-grid__copy">
          <span class="notification-type-card-grid__title">
            <span class="notification-type-card-grid__name">{{ card.label }}</span>
            <NotificationKindBadge
              :kind="card.kind"
              :data-testid="`notification-stepper__kind-badge--${card.feature}`"
            />
          </span>
          <span class="notification-type-card-grid__desc">{{ card.description }}</span>
          <span v-if="card.disabled" class="notification-type-card-grid__disabled">
            {{ card.disabledReason }}
          </span>
        </span>
        <span class="notification-type-card-grid__radio" aria-hidden="true" />
      </button>
    </div>
    <div class="notification-type-card-grid__legend">
      <span class="notification-type-card-grid__legend-item">
        <NotificationKindBadge kind="schedule" />
        {{ scheduleHint }}
      </span>
      <span class="notification-type-card-grid__legend-item">
        <NotificationKindBadge kind="trigger" />
        {{ eventHint }}
      </span>
    </div>
  </div>
</template>

<script>
import { NotificationKindBadge } from '../../../../components/Notifications';
import { NOTIFICATION_FORM_COPY } from '../../../../utils/constants';

export default {
  name: 'NotificationTypeCardGrid',
  components: { NotificationKindBadge },
  props: {
    types: { type: Array, default: () => [] },
    value: { type: String, default: '' },
  },
  data() {
    return {
      query: '',
      heading: NOTIFICATION_FORM_COPY.SELECT_TYPE,
      searchPlaceholder: NOTIFICATION_FORM_COPY.SEARCH_TYPE,
      scheduleHint: NOTIFICATION_FORM_COPY.KIND_SCHEDULE_HINT,
      eventHint: NOTIFICATION_FORM_COPY.KIND_EVENT_HINT,
    };
  },
  computed: {
    filteredTypes() {
      const q = this.query.trim().toLowerCase();
      if (!q) return this.types;
      return this.types.filter((card) => {
        const label = String(card.label || '').toLowerCase();
        const description = String(card.description || '').toLowerCase();
        return label.includes(q) || description.includes(q);
      });
    },
  },
};
</script>
